import {
  ExitToApp,
  Campaign,
  NotificationsActive,
  ManageAccounts,
  AdminPanelSettings,
  SupervisorAccount,
  EventNote,
  FormatListBulletedAdd,
  Style,
  Business,
  AdsClick,
  FormatListBulleted,
  Approval,
  Stars,
  HowToRegOutlined,
  Home,
  AppRegistration,
  Diversity1,
} from "@mui/icons-material";

import EditNoteIcon from "@mui/icons-material/EditNote";

export const menuItems = [
  {
    status: "done",
    label: "Welcome Page",
    to: "/summary",
    icon: <AppRegistration />,
  },
  {
    status: "done",
    label: "Dashboard",
    to: "/",
    icon: <Home />,
  },
  {
    status: "done",
    label: "Administration",
    icon: <AdminPanelSettings />,
    children: [
      {
        status: "done",
        label: "User Management",
        icon: <SupervisorAccount />,
        to: "/user",
      },
      {
        status: "done",
        label: "Department",
        icon: <Business />,
        to: "/department",
      },
      {
        status: "done",
        label: "Job Grade",
        icon: <EditNoteIcon />,
        to: "/job-grade",
      },
      {
        status: "done",
        label: "Value Tag",
        icon: <Style />,
        to: "/value-tag",
      },
      // {
      //   label: "Target Distribute Points",
      //   icon: <TrackChangesOutlined />,
      //   to: "/targetDistribute"
      // },
    ],
  },
  // {
  //   label: "Setup",
  //   icon: <PhonelinkSetup />,
  //   children: [
  //     {
  //       label: "Value Tags",
  //       icon: <Style />,
  //       to: "/valuetags"
  //     },
  //     {
  //       label: "Branch",
  //       icon: <AltRoute />,
  //       to: "/branch"
  //     },
  //     {
  //       label: "Company",
  //       icon: <Business />,
  //       to: "/company"
  //     }
  //   ]
  // },
  {
    status: "done",
    label: "Mission",
    icon: <AdsClick />,
    to: "/mission",
    // children: [
    //   {
    //     status: "done",
    //     label: "Mission",
    //     icon: <FormatListBulleted />,
    //     to: "/mission",
    //   },
    //   // {
    //   //   label: "Mission Approval",
    //   //   icon: <Approval />,
    //   //   to: "/approval"
    //   // }
    // ],
  },
  // {
  //   status: "wip",
  //   label: "Point",
  //   icon: <Stars />,
  //   children: [
  //     {
  //       status: "wip",
  //       label: "Employee Earned Point",
  //       icon: <HowToRegOutlined />,
  //       to: "/earn-point",
  //     },
  //     {
  //       status: "wip",
  //       label: "Employee Distributable Point",
  //       icon: <Approval />,
  //       to: "/distribute-point",
  //     },
  //   ],
  // },
  {
    status: "done",
    label: "Event Announcement",
    icon: <EventNote />,
    to: "/event",
    // children: [
    //   {
    //     status: "done",
    //     label: "Event Announcement",
    //     icon: <FormatListBulletedAdd />,
    //   },
    // ],
  },
  {
    status: "done",
    label: "Campaign",
    icon: <Campaign />,
    to: "/campaign",
    // children: [
    //   {
    //     status: "done",
    //     label: "Campaign",
    //     icon: <FormatListBulleted />,
    //     to: "/campaign",
    //   },
    // ],
  },
  //  {
  //   status: "done",
  //   label: "Team",
  //   to: "/team",
  //   icon: <Diversity1 />,
  // },
  // {
  //   status: "wip",
  //   label: "Notifications",
  //   to: "/notification",
  //   icon: <NotificationsActive />,
  // },
  {
    status: "done",
    label: "Account",
    to: "/account",
    icon: <ManageAccounts />,
  },
  {
    status: "done",
    label: "Logout",
    action: "logout",
    icon: <ExitToApp />,
  },
];
